import { TRACKING_EVENT_NAMES } from 'hooks/analytics_events/constants'

export const trackSendViaCalendly = (track, eventTypeId, contactSource, contactUuid) => {
  track({
    name: TRACKING_EVENT_NAMES.SEND_VIA_CALENDLY,
    properties: {
      event_type_id: eventTypeId,
      contact_source: contactSource?.toLowerCase(),
      contact_uuid: contactUuid,
      step: 'suggest_times'
    }
  })
}
